var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsWohlbefindenHoch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-wohlbefinden-hoch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-wohlbefinden-hoch",
    stroke: "#7F8BDB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,22 C29,26.2997628 25.3981639,30 21,30 C16.6023607,30 13,26.2997628 13,22",
    id: "Stroke-1",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,18 C14,16.9054385 15.3030921,16 16.5693737,16 C17.8350889,16 19,16.9054385 19,18",
    id: "Stroke-3",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,18 C29,16.9054385 27.6969079,16 26.4306263,16 C25.1649111,16 24,16.9054385 24,18",
    id: "Stroke-5",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,21.5002609 C36,29.507782 29.5078988,36 21.5,36 C13.4921012,36 7,29.507782 7,21.5002609 C7,13.4911744 13.4921012,7 21.5,7 C29.5078988,7 36,13.4911744 36,21.5002609 Z",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 21,
    x2: 43,
    y2: 21,
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 3,
    x2: 21,
    y2: 0,
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: 21,
    x2: 0,
    y2: 21,
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 40,
    x2: 21,
    y2: 43,
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 8,
    x2: 36,
    y2: 6,
    id: "Stroke-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 8,
    x2: 6,
    y2: 6,
    id: "Stroke-19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 34,
    x2: 6,
    y2: 36,
    id: "Stroke-21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 34,
    x2: 36,
    y2: 36,
    id: "Stroke-23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsWohlbefindenHoch);
export default __webpack_public_path__ + "static/media/icons-wohlbefinden-hoch.206680f7f4aa735dc8fa75519479c84f.svg";
export { ForwardRef as ReactComponent };